import store from '../store/Store';
import {translations} from './translations';

export default {
    translate: word => {
      return translations[store.getters.currentLanguage][word];
    }
}